"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetSymbol = exports.ChainSlug = void 0;
var ChainSlug;
(function (ChainSlug) {
    ChainSlug["ethereum"] = "ethereum";
    ChainSlug["polygon"] = "polygon";
    ChainSlug["gnosis"] = "gnosis";
    ChainSlug["optimism"] = "optimism";
    ChainSlug["arbitrum"] = "arbitrum";
    ChainSlug["nova"] = "nova";
    ChainSlug["zkSync"] = "zksync";
    ChainSlug["consensyszk"] = "consensyszk";
})(ChainSlug = exports.ChainSlug || (exports.ChainSlug = {}));
var AssetSymbol;
(function (AssetSymbol) {
    AssetSymbol["USDC"] = "USDC";
    AssetSymbol["USDT"] = "USDT";
    AssetSymbol["DAI"] = "DAI";
    AssetSymbol["MATIC"] = "MATIC";
    AssetSymbol["ETH"] = "ETH";
    AssetSymbol["WBTC"] = "WBTC";
    AssetSymbol["HOP"] = "HOP";
    AssetSymbol["SNX"] = "SNX";
    AssetSymbol["sUSD"] = "sUSD";
    AssetSymbol["sBTC"] = "sBTC";
    AssetSymbol["sETH"] = "sETH";
    AssetSymbol["rETH"] = "rETH";
})(AssetSymbol = exports.AssetSymbol || (exports.AssetSymbol = {}));
